// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.txt-red[data-v-be1f9a94] {\n  color:red;\n  font-weight:bold;\n}\n.tooltip_wrap[data-v-be1f9a94] {width:250px; right:0; top:24px; display:none;}\n.tooltip_wrap .cont[data-v-be1f9a94] {padding: 20px;}\n.pl5[data-v-be1f9a94] {padding-left: 5px;}\n", ""]);
// Exports
module.exports = exports;
